RivalIQ.apps.Admin.apps.Company.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.SocialHandles = Marionette.CompositeView.extend({
        template: '#adminCompanySocialHandlesTemplate',

        childViewContainer: '.x-handle-list',
        childView: views.SocialHandle
    });
});
